module.exports = __webpack_public_path__ + "img/09.b4b8bbd7.png";